import api from '../../../modules/api'

// Constant
import { UPDATE_PAYMENTS_DATA, PAYMENT_SET_IS_LOADING } from '../../../modules/actions'

const initialState = {
  isLoading: true,
  payments: []
}

// Action handler
export default (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_PAYMENTS_DATA:
      return {
        ...state,
        ...action.payload
      }
    case PAYMENT_SET_IS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      }
    default:
      return state
  }
}

export const updatePaymentsData = (payload) => ({
  type: UPDATE_PAYMENTS_DATA,
  payload
})


// Actions

export const setIsLoading = (isLoading) => {
  return {
    type: PAYMENT_SET_IS_LOADING,
    payload: isLoading,
  }
}

// Thunks
export function fetchPaymentsDataRequest() {
  return async dispatch => {
    let response = await api.fetchPaymentsInfo()

    if (response.data.payments) {
      let data = response.data.payments
      dispatch(updatePaymentsData({
        payments: data
      }))
    }

    dispatch(setIsLoading(false))
  }
}



// WEBPACK FOOTER //
// ./src/routes/payments/modules/payments.js